import React, { useEffect, useState } from 'react'
import PaginatorComponent from '../PaginatorComponent'
import { deleteEventService, listPlaceEventsService } from '../../Service/EventService'
import { useTranslation } from 'react-i18next'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'
import { toast } from 'react-toastify'
import { Dialog } from 'primereact/dialog'
import EventsForm from '../../App/EventsForm'
import ReactGoogleAutocomplete from 'react-google-autocomplete'
import AppBodyComponent from '../AppBodyComponent'

function ReligiousPlaceEventsComponent({access_key}) {

    const [events, setEvents] = useState()
    const navigate = useNavigate()
    const { t } = useTranslation('user_home');
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(1)
    const [countEvents, setCountEvents] = useState(1)
    const [selectedAccessKey, setSelectedAccessKey] = useState()
    const [openDialog, setOpenDialog] = useState()

    useEffect(()=>{
        handleListEvents()
    },[access_key, page])

    const handleListEvents = () => {
        listPlaceEventsService(access_key, page).then(res=>{
            setEvents(res.rows)
            setTotal(res.pages)
            setCountEvents(res.countResult)
        })
    }

    const handleDelete = (access_key, name) => {
        confirmDialog({
            message: t('events_home_delete_message') + name + '?',
            header: t('events_home_delete_confirmation'),
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept:()=>{
                deleteEventService(access_key).then((res)=>{
                    if (res === true) {
                        toast.success(t('event_home_deleted_message'))
                        handleListEvents()
                    }
                })
            },
            reject:()=>{}
        });
    }

    const handleOpenForm = (event_access_key) => {
        setSelectedAccessKey(event_access_key)
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        handleListEvents()
    }

    return (
        <div className='flex flex-column gap-2'>
            <ConfirmDialog />
            <div className='flex flex-column gap-2'>
                <div className='flex justify-content-between'>
                    <div><span className='font-bold'>{countEvents}</span> {t('user_home_event_count_created')}</div>
                    <Button size='small' icon='pi pi-plus' onClick={()=>handleOpenForm(null)} />
                </div>
                {events && events.length > 0 ? events.map((item, key)=>(
                    <div key={key} className='flex flex-column gap-1 border-1 border-round p-2'>
                        <div className='flex justify-content-between'>
                                <div className='font-bold text-lg'>{item.title}</div>
                                <div className="flex gap-2">
                                    <Button icon='pi pi-pencil' onClick={()=>handleOpenForm(item.access_key)}/>
                                    <Button icon='pi pi-trash' severity="danger" onClick={()=>handleDelete(item.access_key, item.title)} />
                                </div>
                        </div>
                        <div>{new Date(item.date_start).toLocaleDateString()}, {new Date(new Date().toLocaleDateString() +' '+ item.time_start).toLocaleTimeString()}</div>
                        <div>{item.total_going} {t('user_home_event_people_confirmed')}</div>
                    </div>
                ))
                :
                <div></div>}
            </div>
            <PaginatorComponent page={page} setPage={setPage} total={total} />


            <Dialog visible={openDialog} onHide={()=>setOpenDialog(false)}>
                <EventsForm access_key={selectedAccessKey} handleClose={handleCloseDialog} />
            </Dialog>
        </div>
    )
}

export default ReligiousPlaceEventsComponent